var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 2.66666H12C12.3536 2.66666 12.6927 2.80713 12.9428 3.05718C13.1928 3.30723 13.3333 3.64637 13.3333 3.99999V13.3333C13.3333 13.6869 13.1928 14.0261 12.9428 14.2761C12.6927 14.5262 12.3536 14.6667 12 14.6667H3.99996C3.64634 14.6667 3.3072 14.5262 3.05715 14.2761C2.8071 14.0261 2.66663 13.6869 2.66663 13.3333V3.99999C2.66663 3.64637 2.8071 3.30723 3.05715 3.05718C3.3072 2.80713 3.64634 2.66666 3.99996 2.66666H5.33329",
    stroke: "#14142B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.33334H6.00004C5.63185 1.33334 5.33337 1.63182 5.33337 2.00001V3.33334C5.33337 3.70153 5.63185 4.00001 6.00004 4.00001H10C10.3682 4.00001 10.6667 3.70153 10.6667 3.33334V2.00001C10.6667 1.63182 10.3682 1.33334 10 1.33334Z",
    stroke: "#14142B",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivity);
export default __webpack_public_path__ + "static/media/productivity.87f6071eddfe52b87f579931d3c3ae46.svg";
export { ForwardRef as ReactComponent };